import AbstractUploadHelper from "~/ts/library/AbstractUploadHelper";
import LcabApiRequest from "~/cabinet/ts/api/LcabApiRequest";

export default class CabinetUploadHelper extends AbstractUploadHelper {
    getUrl(): string {
        return LcabApiRequest.getUrl(super.getUrl());
    }
}